import React from "react";
import {
    Edit,
    TabbedForm,
    FormTab,
    Toolbar,
    SaveButton,
    BooleanInput,
    TextInput
} from 'react-admin';

const PostEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

class PaymentMethodsEdit extends React.Component {
    render() {

        return [
            <Edit {...this.props} key={"payment_methods-edit"}>

                <TabbedForm toolbar={<PostEditToolbar />}>
                    <FormTab label={"general"}>
                        <BooleanInput label="Enable" source="enabled" />
                        <TextInput
                            label="Payment info text"
                            source="description"
                            multiline
                            fullWidth
                        />
                        <TextInput
                            label="Payment info footer text"
                            source="paymentInfoFooterText"
                            multiline
                            fullWidth
                            helperText="Use %order_number% for order number"
                        />
                    </FormTab>
                </TabbedForm>
            </Edit>

        ]
    }
}

export default PaymentMethodsEdit
